import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import {
  IBienLaiThuPaging,
  IPagingBienLaiResult,
} from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IBienLaiPagingActionTypes } from "../../action-types/bien-lai/IBienLaiPagingActionTypes";
import { IBienLaiPagingReducer } from "../../reducer-model/bien-lai/IBienLaiPagingReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiPagingReducer = {
  bienLais: {} as IPagingBienLaiResult,
  request: {
    id_hes: [],
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    id_khoi_nganhs: [],
    page_index: 0,
    page_size: 100,
    search_key: "",
    id_chuyen_nganhs: [],
    id_khoas: [],
    id_hinh_thuc_thanh_toans: [],
    loai_phieu: "all",
    trang_thai_phieu: "hoan-thanh",
    nguoi_thu: "",
    id_co_sos: [],
  } as IBienLaiPagingRequest,
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  idShowViewDetail: 0,
  bienLaiHuy: undefined,
  isShowFilter: false,
} as IBienLaiPagingReducer;

export const bienLaiPagingReducer = (
  state: IBienLaiPagingReducer = iniState,
  action: IBienLaiPagingActionTypes
): IBienLaiPagingReducer => {
  switch (action.type) {
    case "BIEN_LAI_PAGING_LOAD_START":
      return {
        ...state,
        bienLais: {} as IPagingBienLaiResult,
        request: action.payload,
        status: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_LOAD_SUCCESS":
      return {
        ...state,
        bienLais: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_LOAD_ERRR":
      return {
        ...state,
        bienLais: {} as IPagingBienLaiResult,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    case "BIEN_LAI_PAGING_SHOW_DETAIL_MODAL":
      return {
        ...state,
        idShowViewDetail: action.payload,
      };
    case "BIEN_LAI_PAGING_HIDE_DETAIL_MODAL":
      return {
        ...state,
        idShowViewDetail: 0,
      };
    case "BIEN_LAI_PAGING_HUY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "BIEN_LAI_PAGING_HUY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        bienLaiHuy: undefined,
      };
    case "BIEN_LAI_PAGING_HUY_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "BIEN_LAI_PAGING_SHOW_HUY_MODAL":
      return {
        ...state,
        bienLaiHuy: action.payload,
      };
    case "BIEN_LAI_PAGING_HIDE_HUY_MODAL":
      return {
        ...state,
        bienLaiHuy: undefined,
      };
    case "BIEN_LAI_PAGING_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_EXPORT_EXCEL_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_START":
      return {
        ...state,
        request: {
          ...state.request,
          mau_so: action.payload.mau_so,
        },
        statusExport: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: action.payload,
      };
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_CLOSE":
    case "BIEN_LAI_PAGING_PRINT_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: undefined,
      };
    default:
      return state;
  }
};
